import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import './ProposalSummaryItem.css';

type ProposalSummaryItemProps = {
    proposalType?: string;
    threeBProductName: string;
    productGroupType?: string;
    advisorName?: string;
    agentName?: string;
    proposalOwner?: string;
    selectedLanguage?: string;
}

export const ProposalSummaryItem: FC<ProposalSummaryItemProps> = ({
    proposalType = 'NEW',
    productGroupType = '3a',
    threeBProductName,
    advisorName,
    agentName,
    proposalOwner,
    selectedLanguage,
}) => {
    const { t } = useTranslation();

    return (
        <section className="proposal-summary-item">
            <p className="title">
                <span>
                    {t(proposalType)}
                    {' '}
                    {productGroupType}
                    {' '}
                    {t('proposalSummary.title.proposal')}
                </span>
                {threeBProductName ? ` - ${threeBProductName}` : ''}
            </p>
            <div className="data-row">
                <p>{t('ProposalSummary.ProposalOwner')}</p>
                <p>
                    {proposalOwner}
                </p>
            </div>
            <div className="data-row">
                <p>{t('ProposalSummary.productOffer')}</p>
                <p>
                    {productGroupType}
                </p>
            </div>
            {threeBProductName && (
                <div className="data-row">
                    <p>{t('ProposalSummary.3bProductName')}</p>
                    <p>
                        {threeBProductName}
                    </p>
                </div>
            )}
            <div className="data-row">
                <p>{t('dashboard.overviewClientApplications.advisor')}</p>
                <p>
                    {advisorName}
                </p>
            </div>
            <div className="data-row">
                <p>{t('portfolio.createNewPortfolio.agentInformation.generalAgency')}</p>
                <p>
                    {agentName}
                </p>
            </div>
            <div className="data-row">
                <p>{t('portfolio.createNewPortfolio.opening.documentLanguage')}</p>
                <p>
                    {selectedLanguage}
                </p>
            </div>
        </section>
    );
};
